import React, { Component, Fragment } from 'react';
import CategoriesTitle from './categories.title';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../store/actions';
import { Link, withRouter } from 'react-router-dom';
import { API, CURRENCY } from '../../constants';
import { formatMoney } from '../../services';
import Pagination from 'rc-pagination';
import { TYPE_PRODUCT } from '../../constants';
import { firstUpperCase } from '../../utils';

class CategoriesMain extends Component {
    onChange = page => {
        const { CurrentPageChange } = this.props;
        CurrentPageChange(page);
        window.scrollTo(0, 0);
    };

    render() {
        const {
            rowsPerPage,
            categoryData,
            currentPage,
            totalItems,
            history,
            wording,
            currentLanguage,
            navbarCategory,
            category,
            AssignCategory,
            basenameURL
        } = this.props;

        const categoryName = currentLanguage === 'TH' ? category.categoryNameTh : category.categoryNameEn;

        return (
            <>
                <CategoriesTitle page={categoryName} />
                <section className='section-wrap pt-70 pb-40 catalogue'>
                    <div className='container relative'>
                        <div className='row'>
                            <div className='col-md-12 mb-50'>
                                {categoryData && categoryData.length === 0 && (
                                    <div className='shop-catalogue grid-view'>
                                        <div className='row text-center'>
                                            <div className='col-md-10 col-md-offset-1'>
                                                <div className='icon-warpper'>
                                                    <img src='/assets/img/sf/not-found.png' alt='not-found.png' />
                                                </div>
                                                <h1 className='uppercase'>{wording.unableItem.bodyMessage}</h1>
                                                <p className='white'>
                                                    {wording.unableItem.urlMessage1}{' '}
                                                    <Link to={`${basenameURL}`}>
                                                        {currentLanguage === 'TH'
                                                            ? navbarCategory[0]?.categoryNameTh
                                                            : navbarCategory[0]?.categoryNameEn}
                                                    </Link>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {categoryData && categoryData.length !== 0 && (
                                    <div className='shop-catalogue grid-view'>
                                        <div className='row items-grid'>
                                            {categoryData
                                                .slice(
                                                    (currentPage - 1) * rowsPerPage,
                                                    (currentPage - 1) * rowsPerPage + rowsPerPage
                                                )
                                                .map((item, index) => {
                                                    const urlToProductDetail = `${basenameURL}/${category[`categoryName${firstUpperCase(currentLanguage.toLowerCase())}`] === TYPE_PRODUCT.VOUCHER[currentLanguage].toUpperCase() ? "voucher" : "product"}/${item.name
                                                        .split(' ')
                                                        .join('-')}`;
                                                    return (
                                                        <div
                                                            key={index}
                                                            className='col-md-3 col-sm-6 col-xs-6 product product-grid'>
                                                            <div className='product-item mb-20'>
                                                                <div className='product-img hover-1'>
                                                                    <div
                                                                        className="background-img"
                                                                        style={{ minWidth: "99.9%", height: "380px", backgroundImage: `url('${API.PRODUCT_IMG_URL}${item.img}')` }} />

                                                                    {item.overTag && (
                                                                        <span className='sold-out valign'>
                                                                            {wording.homePage.newArrivals.outOfStock}
                                                                        </span>
                                                                    )}
                                                                    {
                                                                        item.tag && (
                                                                            <div className='product-label label-left'>
                                                                                <span
                                                                                    className={
                                                                                        item.tag === 'SALE'
                                                                                            ? 'sale'
                                                                                            : item.tag === 'HOT'
                                                                                                ? 'hot'
                                                                                                : null
                                                                                    }>
                                                                                    {item.tag}
                                                                                </span>
                                                                            </div>
                                                                        )
                                                                    }
                                                                    {
                                                                        item.promotionName && (
                                                                            <div className='product-label label-right flex horizontal-end wrap'>
                                                                                {
                                                                                    item.promotionName.map((item, index) =>
                                                                                        <span className='pro cut-text ml-10 mb-10' key={index}>
                                                                                            {item}
                                                                                        </span>
                                                                                    )
                                                                                }
                                                                            </div>
                                                                        )
                                                                    }
                                                                    <div
                                                                        className='hover-overlay pointer'
                                                                        onClick={() => {
                                                                            AssignCategory(category)
                                                                            history.push(urlToProductDetail);
                                                                        }}
                                                                    />
                                                                </div>

                                                                <div className='product-details'>
                                                                    <h3>
                                                                        <Link
                                                                            to={urlToProductDetail}
                                                                            className='btn-quickview'>
                                                                            <div className='product-title cut-text'>
                                                                                {item.name}
                                                                            </div>
                                                                        </Link>
                                                                    </h3>
                                                                    {item.promotionPrice > 0 && item.promotionPrice < item.price ? (
                                                                        <span className='price'>
                                                                            <del>
                                                                                <span>{`${CURRENCY.B}${formatMoney(
                                                                                    item.price
                                                                                )}`}</span>
                                                                            </del>
                                                                            <ins>
                                                                                <span className='ammount'>{`${
                                                                                    CURRENCY.B
                                                                                }${formatMoney(
                                                                                    item.promotionPrice
                                                                                    )}`}</span>
                                                                            </ins>
                                                                        </span>
                                                                    ) : (
                                                                        <span className='price'>
                                                                            <ins>
                                                                                <span className='ammount'>{`${
                                                                                    CURRENCY.B
                                                                                    }${formatMoney(
                                                                                        item.price
                                                                                    )}`}</span>
                                                                            </ins>
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        {totalItems > rowsPerPage && (
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center'
                                }}>
                                <Pagination
                                    onChange={this.onChange}
                                    current={currentPage}
                                    pageSize={rowsPerPage}
                                    total={totalItems}
                                    showTitle={false}
                                />
                            </div>
                        )}
                    </div>
                </section>
            </>
        );
    }
}

const mapStateToProps = ({ categories, language, navigation }) => ({
    categoryData: categories.categoryData,
    totalItems: categories.totalItems,
    paginationSize: categories.paginationSize,
    rowsPerPage: categories.rowsPerPage,
    currentPage: categories.currentPage,
    indexSelected: categories.indexSelected,
    wording: language.wording,
    currentLanguage: language.currentLanguage,
    navbarCategory: navigation.navbarCategory,
    basenameURL: language.basenameURL
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            CurrentPageChange: Actions.CurrentPageChange,
            AssignCategory: Actions.AssignCategory
        },
        dispatch
    );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CategoriesMain));
